module.exports = __webpack_public_path__ + "4aa22a8e96de2ba7fb098b2690e3835f.png";